import Header from './components/Header';
import Tabs from './components/Tabs';
import A from './components/A';
import B from './components/B';
import C from './components/C';
// import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useGlobal } from '@/utils/useGlobal';

export default function DeltaProUltraPreLaunch() {
    const { useState, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [num, setNum] = useState(0);
    const [buyLink, setBuyLink] = useState('');
    const [hasHeader, setHaseHeader] = useState(true);
    const LOCAL_SITES: string[] = ['jp'];
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`delta-pro-ultra-prelaunch ${css['delta-pro-ultra-prelaunch']}`}>
            {!LOCAL_SITES.includes(locale) && <Header callback={() => setHaseHeader(false)} />}
            <A callback={setNum} buyLink={buyLink} />
            {!LOCAL_SITES.includes(locale) && <Tabs hasHeader={hasHeader} />}
            {!LOCAL_SITES.includes(locale) && <C callback={setBuyLink} />}
            <B />
            {!LOCAL_SITES.includes(locale) && <I />}
            {!LOCAL_SITES.includes(locale) && <G />}
            {/* {!LOCAL_SITES.includes(locale) && <D />} */}
            {!LOCAL_SITES.includes(locale) && <E number={num} buyLink={buyLink} />}
            <H />
            {!LOCAL_SITES.includes(locale) && <F />}
        </div>
    );
}
